import "./CompactEssayList.scss";

import React from "react";

import essayMetadata, { EssayID } from "../essays/essayMetadata";

interface Props {
  orderedEssayIDs: readonly EssayID[];
  activeEssayID?: EssayID;
}

export default function CompactEssayList(props: Props) {
  return (
    <ul className="CompactEssayList">
      {props.orderedEssayIDs.map(essayID => {
        const { title, hidden } = essayMetadata[essayID];
        return (
          <li
            key={essayID}
            className={
              essayID === props.activeEssayID
                ? "Active"
                : hidden
                ? "Disabled"
                : undefined
            }
          >
            {/* Client-side navigation is broken because of our rendering chicanery. TODO: fix and re-enable */}
            {/* <NavLink to={`/${essayID}`}> */}
            {essayMetadata[essayID].hidden ? (
              <span>{title} (coming soon)</span>
            ) : (
              <a href={`/${essayID}`}>{title}</a>
            )}
            {/* </NavLink> */}
          </li>
        );
      })}
    </ul>
  );
}
